import React from 'react'

export const NotificationPage = React.lazy(() => import('./notifition-page'))
